import React from 'react';
import PropTypes from 'prop-types';
export class ToolbarButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = () => {
            try {
                this.props.onClick();
                this.setState({ error: null });
            }
            catch (error) {
                this.setState({ error });
            }
        };
        this.state = { error: null };
    }
    render() {
        const { error } = this.state;
        return (React.createElement("button", { className: 'toolbar-button' + (error ? ' error' : ''), onClick: this.handleClick, title: error ? error.message : this.props.title, "aria-invalid": error ? 'true' : 'false' }, this.props.label));
    }
}
ToolbarButton.propTypes = {
    onClick: PropTypes.func,
    title: PropTypes.string,
    label: PropTypes.string,
};
//# sourceMappingURL=ToolbarButton.js.map